import { Floor } from "@pdfking/math"

import type { RandomStream } from "#internal"

export const RandomPick = <T>(random: RandomStream, items: ArrayLike<T>): T =>
  items[Floor(random() * items.length)]!
